<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isExtWarrAdmin()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Customers | Master</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>
<!-- main row for all icons  -->
<div class="col-lg-12">
<div class="col-lg-10 center center-block" align="center">
	<div class="card card-primary card-outline">
		<div class="card-header">
			
		</div>
		<div class="card-body overflow-auto">
			<div class="col-md-10 float-left">
			<div class="row">
				
      	<!--<div>
         		<div class="row">
         		<div class="col-sm-3" v-for="(file, key) in files" style="margin-top: 1%;">
         			<button type="button" class="close float-right" aria-label="Remove">
         				<span v-on:click="removeFile( key )">×</span>
         			</button>
         			<img v-if="file.url" :src="file.url" width="150px" height="150px"/>
         		</div>
         		</div>
         		<input type="file" ref="file" id="file" name="image" multiple @change="addFile" placeholder="Upload image of the invoice">
         		<button class="btn btn-danger fa fa-plus" @click="triggerClick" style="margin-top: 5%;"> Add Image</button>
         </div>
         <div>
         		<button type="button" class="btn btn-primary" @click="uploadImage">Upload</button>
         </div>-->
      </div>
      </div>
      
			<!-- content here -->

    </div>
    <div class="card-footer">
    	
		</div>
	</div>
</div>
</div>
<!-- row end -->
    </section>
    <!-- /.content -->


    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isExtWarrAdmin()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		 export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        data(){
        	return {
        		image: '',
						imgURL: '',
						images: [],
						files: []
        	}
        },
        
        methods: {
        	triggerClick(){
       	 		this.$refs.file.click();
       	 	},
       	 	
       	 	removeFile( key ){
  					this.files.splice( key, 1 );
					},
       	 	
       	 	addFile(){
    				let uploadedFiles = this.$refs.file.files;
						
  						// Adds the uploaded file to the files array
						
						for( var i = 0; i < uploadedFiles.length; i++ ){
							let temp = {file: uploadedFiles[i], url: URL.createObjectURL(uploadedFiles[i])};
  						this.files.push(temp);
						}
    			},
       	 	
       	 	uploadImageModal(p){
       	 		this.job_id = p.id;
       	 		$("#imageModal").modal("show");
       	 	},
       	 	
       	 	uploadImage(){
       	 		var formData = new FormData();
       	 		formData.set('job_id', 10);
       	 		for( var i = 0; i < this.files.length; i++ ){
  						let file = this.files[i].file;
  						console.log(file);
  						formData.append('files[' + i + ']', file);
						}
						
       	 		axios({
    					method: 'post',
    					url: '/api/uploadImages',
    					data: formData,
    					headers: {'Content-Type': 'multipart/form-data'},
    				})
    					.then(()=>{
      	     		toast.fire({
      		      	type: 'success',
                	title: 'Invoice Uploaded'
            		});
    				})
    				.catch((error)=>{
            	toast.fire({
      	      	type: 'error',
              	title: 'Upload Valid Image'
            	}); 
          	})
       	 	}
        }
    }
</script>
